module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top-bar"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("apply.applyType")))])]), _vm._v(" "), _c('ul', {
    staticClass: "bao-type"
  }, _vm._l((_vm.con_fee), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selectApply(item.feeId, item.feeFl)
        }
      }
    }, [_c('p', {
      class: [_vm.info.reg_config.cfgDefFeeid == item.feeId ? 'active' : '', item.feeFl == '0' ? 'cant_select_fee' : '']
    }, [_c('span', [_vm._v(_vm._s(item.feeName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.feeMoney) + _vm._s(_vm.locale == 'en' ? "CNY" : "元"))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "top-bar"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("apply.applyPayType")))])]), _vm._v(" "), _c('div', {
    staticClass: "pay-type"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reg_config.cfgPayOnlineFl == '1' && _vm.reg_config.cfgPayOfflineFl == '1'),
      expression: "reg_config.cfgPayOnlineFl=='1' && reg_config.cfgPayOfflineFl=='1'"
    }],
    staticClass: "clear"
  }, [_c('div', {
    staticClass: "left pay-type-box"
  }, [(_vm.reg_config.cfgPayOnlineFl == '1') ? _c('p', {
    staticClass: "pay-type-item",
    on: {
      "click": function($event) {
        _vm.setPayType(1)
      }
    }
  }, [_c('span', {
    staticClass: "pay-type-item-icon"
  }, [_c('i', {
    class: {
      active: _vm.pay_type == 1 ? true : false, bounce2: _vm.pay_type == 1 ? true : false
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pay.payOnline")))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "left pay-type-box"
  }, [(_vm.reg_config.cfgPayOfflineFl == '1') ? _c('p', {
    staticClass: "pay-type-item",
    on: {
      "click": function($event) {
        _vm.setPayType(2)
      }
    }
  }, [_c('span', {
    staticClass: "pay-type-item-icon"
  }, [_c('i', {
    class: {
      active: _vm.pay_type == 2 ? true : false, bounce2: _vm.pay_type == 2 ? true : false
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pay.payOffline")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reg_config.cfgPayOnlineFl == '0' || _vm.reg_config.cfgPayOfflineFl == '0'),
      expression: "reg_config.cfgPayOnlineFl=='0' || reg_config.cfgPayOfflineFl=='0'"
    }],
    staticClass: "clear"
  }, [(_vm.reg_config.cfgPayOfflineFl == '1') ? _c('div', {
    staticClass: "pay-type-box",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', {
    staticClass: "pay-type-item",
    on: {
      "click": function($event) {
        _vm.setPayType(2)
      }
    }
  }, [_c('span', {
    staticClass: "pay-type-item-icon"
  }, [_c('i', {
    class: {
      active: _vm.pay_type == 2 ? true : false, bounce2: _vm.pay_type == 2 ? true : false
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pay.payOffline")))])])]) : _vm._e(), _vm._v(" "), (_vm.reg_config.cfgPayOnlineFl == '1') ? _c('div', {
    staticClass: "pay-type-box",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('p', {
    staticClass: "pay-type-item",
    on: {
      "click": function($event) {
        _vm.setPayType(1)
      }
    }
  }, [_c('span', {
    staticClass: "pay-type-item-icon"
  }, [_c('i', {
    class: {
      active: _vm.pay_type == 1 ? true : false, bounce2: _vm.pay_type == 1 ? true : false
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("pay.payOnline")))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tip",
    domProps: {
      "innerHTML": _vm._s(_vm.reg_config.cfgFeeDesc)
    }
  }), _vm._v(" "), (_vm.opFlag != '1') ? _c('div', {
    staticClass: "clear btn-box"
  }, [_c('div', {
    staticClass: "btn pre left",
    on: {
      "click": _vm.pre
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("btn.pre")))])]), _vm._v(" "), _c('div', {
    staticClass: "btn next right",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("btn.next")))])])]) : _vm._e(), _vm._v(" "), (_vm.opFlag == '1') ? _c('div', {
    staticClass: "clear btn-box",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.next
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("btn.next")))])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-175b862d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/apply.vue
// module id = 772
// module chunks = 10